import { RouteWidgetBaseParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/types';
import { ContainerParameters } from '@services/requests/orderService/types';
import { TransportCountByType } from '@services/requests/routeCalculator/cargoConverterService/SelectCargoParametersQuery';
import React from 'react';

import { FullResultContainer } from './FullResultContainer';
import { ShortResultContainer } from './ShortResultContainer';

type CargoSelectionResultItemContainerProps =
  | {
      outputType: 'full';
      containerParameter: ContainerParameters;
      mainLanguage: string;
      BaseData: RouteWidgetBaseParameters;
      containerIndex: number;
    }
  | {
      outputType: 'short';
      containerParameter: TransportCountByType;
      mainLanguage: string;
      BaseData: RouteWidgetBaseParameters;
      containerIndex: number;
    };

function CargoSelectionResultItemContainer({
  containerParameter,
  mainLanguage,
  BaseData,
  containerIndex,
  outputType,
}: CargoSelectionResultItemContainerProps) {
  switch (outputType) {
    case 'full':
      return (
        <FullResultContainer
          BaseData={BaseData}
          containerIndex={containerIndex}
          mainLanguage={mainLanguage}
          containerParameter={containerParameter}
        />
      );
    case 'short':
      return (
        <ShortResultContainer
          BaseData={BaseData}
          containerParameter={containerParameter}
          mainLanguage={mainLanguage}
        />
      );
    default:
      return null;
  }
}

export { CargoSelectionResultItemContainer };
